module.exports = __webpack_public_path__ + "static/media/facebook.7572a97d.svg";